import { PreferencesParam } from 'src/enums/PreferencesParam';
import { localStorageService } from 'src/services/localStorage/localStorageService';

class PreferencesService {
  set(name: PreferencesParam, value: string | number | boolean | object): void {
    return localStorageService.set(name, value);
  }

  get(name: PreferencesParam): string | number | boolean | object | null {
    switch (name) {
      case PreferencesParam.SIDEBAR_CLOSE:
        return localStorageService.get(name, 'boolean');
      default:
        return localStorageService.get(name);
    }
  }

  remove(name: PreferencesParam): void {
    return localStorageService.remove(name);
  }
}

export const preferencesService = new PreferencesService();
